import { JSX, Show } from "solid-js";
import styles from "./EmptyState.module.css";

import bots from "../assets/empty/bots.svg?raw";
import inventory from "../assets/empty/inventory.svg?raw";
import audit from "../assets/empty/audit.svg?raw";
import notifications from "../assets/empty/notifications.svg?raw";
import players from "../assets/empty/players.svg?raw";
import jobs from "../assets/empty/jobs.svg?raw";
import oauth from "../assets/empty/oauth.svg?raw";
import scans from "../assets/empty/scans.svg?raw";
import generic from "../assets/empty/generic.svg?raw";

export type EmptyIllustration =
  | "bots" | "inventory" | "audit" | "notifications"
  | "players" | "jobs" | "oauth" | "scans" | "generic";

const ILLUSTRATIONS: Record<EmptyIllustration, string> = {
  bots, inventory, audit, notifications, players, jobs, oauth, scans, generic,
};

interface EmptyStateProps {
  icon?: string;
  illustration?: EmptyIllustration;
  title: string;
  hint?: string;
  action?: JSX.Element;
}

export function EmptyState(props: EmptyStateProps) {
  return (
    <div class={styles.empty}>
      <Show when={props.illustration} fallback={
        <Show when={props.icon}>
          <i class={`fa-solid ${props.icon}`} aria-hidden="true" />
        </Show>
      }>
        <div class={styles.illustration} innerHTML={ILLUSTRATIONS[props.illustration!]} />
      </Show>
      <h3 class={styles.title}>{props.title}</h3>
      <Show when={props.hint}>
        <p class={styles.hint}>{props.hint}</p>
      </Show>
      <Show when={props.action}>
        <div class={styles.action}>{props.action}</div>
      </Show>
    </div>
  );
}
